/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addVisitPoint({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/visit/point", item)
				.then((response) => {
					// No se hace mutación al estado porque este se actualiza cada vez que se carga la lista
					// commit('ADD_VISIT_POINT', Object.assign(item, { id: response.data.id }))
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchVisitPoint({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/visit/point")
				.then((res) => {
					commit("SET_VISIT_POINTS", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchVisitPointPaginated({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 10,
				id: data.id && data.id.length > 0 ? data.id.map(Number) : [],
				status_id: data.status_id || [], // {id: 2, name: "ACTIVE"} {id: 8, name: "BANNED"}  {id: 9, name: "DELETED"} {id: 10, name: "FINISHED"} {id: 4, name: "INACTIVE"}
				category_id: [],
				name: data.name || "",
				identification: data.identification || "",
				address: data.address || "",
				city: data.city || "",
				phone: "",
				order_by: data.order_by || "name",
				sort: data.sort || "ASC",
				resource_id: data.resource_id || null,
				additional_info: data.additional_info || null,
				typology_id: data.typology_id || [],
				exact_values: data.exact_values || false,
				fields: [
					"id",
					"name",
					"identification",
					"address",
					"city",
					"department",
					"country",
					"phone",
					"cx",
					"cy",
					"additional_info",
					"status_id",
					"status_name",
					"typology_id",
					"typology_name",
					"category_id",
					"resource_id",
					"total_resource",
					"visit_point_user_id",
				],
				on_demand: data.on_demand || null,
			};
			Api.post("/visit/point/filter", payload)
				.then((res) => {
					commit("SET_VISIT_POINTS", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchVisitPointById({commit}, id) {
		return new Promise((resolve, reject) => {
			const payload = {
				id: [+id],
			};
			Api.post("/visit/point/filter", payload)
				.then((res) => {
					resolve(res.data.records[0]);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchVisitpointsnotscheduled({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/visitpointsnotscheduled`, payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateVisitPoint({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/visit/point/${item.id}`, item)
				.then((response) => {
					commit("UPDATE_VISIT_POINT", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeVisitPoint({commit}, id) {
		const payload = {
			visitpoint_id: [id],
		};
		return new Promise((resolve, reject) => {
			Api.post(`/visit/point/delete`, payload)
				.then((response) => {
					commit("REMOVE_VISIT_POINT", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDivipola({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/divipola`, payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	currentVisitPointSelected({commit}, visitPoint) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_VISIT_POINT", visitPoint);
			resolve(visitPoint);
		});
	},
	setSelectedVisitPoint({commit}, data) {
		commit("SET_SELECTED_VISIT_POINTS", data);
	},
	removeMassiveVisitPoint({commit}) {
		return new Promise((resolve, reject) => {
			Api.delete(`/visit/point`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeMultiVisitPoint({commit}, visitPointIds) {
		return new Promise((resolve, reject) => {
			Api.post("/visit/point/delete", visitPointIds)
				.then((response) => {
					commit("REMOVE_SELECTED_VISIT_POINT", visitPointIds.visitpoint_id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getVisitPoints({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || null,
				quantity: data.quantity || null,
				fields: ["id", "name", "identification", "address", "city", "cx", "cy"],
				id: data.id && data.id.length > 0 ? data.id.map(Number) : [],
				status_id: [],
				typology_id: [],
				category_id: [],
				name: data.name || "",
				identification: data.identification || "",
				address: data.address || "",
				city: data.city || "",
				phone: "",
				additional_info: [],
				order_by: data.order_by || "name",
				sort: data.sort || "ASC",
				resource_id: data.resource_id || null,
			};
			Api.post("/visit/point/filter", payload)
				.then((res) => {
					if (data.assign) {
						commit("SET_ASSIGNED_VISIT_POINT", res.data.records);
					} else {
						commit("SET_VISIT_POINTS", res.data.records);
					}
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	downloadVisitPoints({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/download/visit/point", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	sendCode({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/visit/point/code", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
